import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { TextField } from "@mui/material";

export const matchNothingRegex = /(?!)/;

const RegexTextField = ({ regex, onChange, ...rest }) => {


  const handleChange = useCallback(
    (e) => {
      e.currentTarget.value = e.currentTarget.value.replace(regex, "");
      onChange(e);
    },
    [onChange, regex]
  );

  return (
    <TextField
     style={{
        marginLeft: "8px",   // theme.spacing(1) = 8px
        marginRight: "8px",
        width: "47.5%",
      }}
      inputProps={{
        maxLength: 3,
      }}
      margin="normal"
      variant="outlined"
      id="outlined-margin-normal"
      onChange={handleChange}
      {...rest}
    />
  );
};
// const useStyles = makeStyles((theme) => ({
//   textField: {
//     marginLeft: theme.spacing(1),
//     marginRight: theme.spacing(1),
//     width: "47.5%",
//   },
// }));

export default React.memo(RegexTextField);

RegexTextField.propTypes = {
  onChange: PropTypes.func.isRequired,
  regex: PropTypes.instanceOf(RegExp),
};

RegexTextField.defaultProps = {
  regex: matchNothingRegex,
};
